import { TextField, Typography, Box } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const OfferLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "offer_date" || key === "joining_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>

            

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Offer Letter Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.offer_date ? formatDateForInput(data.offer_date) : ""}
                        onChange={(e) => handleChange("offer_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Joining Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.joining_date ? formatDateForInput(data.joining_date) : ""}
                        onChange={(e) => handleChange("joining_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                        extraOptions={["Trainee"]}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Monthly Salary"
                        fullWidth
                        value={data.monthly_salary || ""}
                        onChange={(e) => {
                            const monthly = e.target.value;
                            handleChange("monthly_salary", monthly);
                            handleChange("salary", monthly * 12);
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default OfferLetterForm;
